import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' // progress bar style
import routes from './routes'
import { ACCESS_TOKEN } from '@/store/mutation-types'

Vue.use(Router)
NProgress.configure({ showSpinner: false }) // NProgress Configuration
// 添加以下代码
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const whiteList = ['Homepage', '404', 'researchField', 'index', 'newInformation', 'headlineRecommendation',
  'edp', 'lowCarbonLife', 'earthMuGe', 'platformPartners', 'expert', 'textContent', 'footer', 'selectContent', 'textTwoContent'] // no redirect whitelist

export const createRouter = () =>
  new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })

const router = createRouter()

router.beforeEach((to, from, next) => {
  NProgress.start()
  const token = Vue.ss.get(ACCESS_TOKEN)
  if (token) {
    if (to.name === 'Homepage') {
      next('/')
    } else {
      next()
    }
  } else {
    if (whiteList.includes(to.name)) {
      next()
    } else {
      // alert(to.name)
      next({ path: '/index' })
    }
  }

  // if (to.name === 'Homepage') {
  //   next('/')
  // } else {
  //   next()
  // }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

export default router
